export const guardianKeys = {
  all: ['guardian'] as const,
  profile: (guardianId?: string) => [...guardianKeys.all, 'profile', guardianId ?? null] as const,
  players: (guardianId?: string) => [...guardianKeys.all, 'players', guardianId ?? null] as const,
  notifications: (guardianId?: string) =>
    [...guardianKeys.all, 'notifications', guardianId ?? null] as const,
} as const;
